// extracted by mini-css-extract-plugin
export var joinContainer = "Join-module--join-container--Qw+Ue";
export var startButtons = "Join-module--start-buttons--YNLy4";
export var text = "Join-module--text--UOqiM";
export var title = "Join-module--title--brzqM";